import React from 'react';
import { MapPin, Clock, DollarSign } from 'lucide-react';

const AREA_TYPE_LABELS = {
  city: 'City',
  county: 'County',
  state: 'Region',
  country: 'Country',
  custom: 'Service area',
};

const VendorServiceAreas = ({ areas = [], preview = false }) => {
  if (!areas?.length) {
    if (preview) {
      return (
        <p className="text-xs italic text-m-ink-muted">
          No active service areas yet. Add a location and keep it active to show it here.
        </p>
      );
    }
    return null;
  }

  return (
    <div className={preview ? '' : 'border-b border-m-border-light pb-6'}>
      {!preview ? (
        <>
          <h2 className="marketing-display-md mb-4 text-m-ink">Service areas</h2>
          <p className="mb-4 text-sm text-m-ink-muted">
            This vendor serves clients in the following locations.
          </p>
        </>
      ) : null}
      <div
        className={`grid grid-cols-1 ${preview ? 'gap-2' : 'gap-3 sm:grid-cols-2'}`}
      >
        {areas.map((area) => {
          const geo = [area.city, area.state, area.country].filter(Boolean).join(', ');
          return (
            <div
              key={area.id}
              className={`flex rounded-2xl border border-m-border-light bg-m-surface ${
                preview ? 'gap-2 p-3' : 'gap-3 p-4'
              }`}
            >
              <div
                className={`flex shrink-0 items-center justify-center rounded-lg bg-m-ink text-white ${
                  preview ? 'h-7 w-7' : 'h-9 w-9'
                }`}
              >
                <MapPin className={preview ? 'h-3.5 w-3.5' : 'h-4 w-4'} />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-m-ink">{area.area_name}</p>
                <p className="mt-0.5 text-xs text-m-ink-muted">
                  {AREA_TYPE_LABELS[area.area_type] || 'Area'}
                  {geo ? ` · ${geo}` : ''}
                </p>
                <div className="mt-2 flex flex-wrap gap-2 text-[11px] text-m-ink-muted">
                  {Number(area.travel_fee) > 0 ? (
                    <span className="inline-flex items-center gap-0.5">
                      <DollarSign className="h-3 w-3" />+
                      {Number(area.travel_fee).toFixed(0)} travel
                    </span>
                  ) : null}
                  {Number(area.travel_time_minutes) > 0 ? (
                    <span className="inline-flex items-center gap-0.5">
                      <Clock className="h-3 w-3" />~{area.travel_time_minutes} min
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VendorServiceAreas;
